import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SoftwareDevelopmentRoutingModule } from './software-development-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SoftwareDevelopmentRoutingModule
  ]
})
export class SoftwareDevelopmentModule { }
